import React from "react";
import { motion } from "framer-motion";

const Leaf = ({ d, className = "" }) => (
  <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
    <path d={d} fill="currentColor" />
  </svg>
);

// Simple hand-drawn leaf silhouettes
const LEAVES = [
  "M50 6 C 30 30 10 45 12 70 C 14 95 45 95 50 94 C 55 95 86 95 88 70 C 90 45 70 30 50 6 Z",
  "M20 20 C 50 10 90 30 90 60 C 90 90 50 92 30 78 C 15 68 8 45 20 20 Z",
  "M50 4 C 24 24 16 60 30 84 C 40 100 68 92 74 78 C 92 40 74 18 50 4 Z",
];

export default function FloatingLeaves({ count = 8, tint = "rgba(33,75,56,0.10)" }) {
  const items = Array.from({ length: count }).map((_, i) => {
    const d = LEAVES[i % LEAVES.length];
    const top = (i * 137) % 90;
    const left = (i * 83) % 92;
    const size = 40 + ((i * 17) % 90);
    const delay = (i % 6) * 0.6;
    const dur = 14 + ((i * 3) % 12);
    const rot = (i * 47) % 360;
    return { d, top, left, size, delay, dur, rot, i };
  });
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 overflow-hidden"
      style={{ color: tint }}
    >
      {items.map((it) => (
        <motion.div
          key={it.i}
          className="absolute"
          style={{
            top: `${it.top}%`,
            left: `${it.left}%`,
            width: it.size,
            height: it.size,
            rotate: it.rot,
          }}
          initial={{ y: 0, opacity: 0 }}
          animate={{
            y: [0, -20, 10, -10, 0],
            x: [0, 12, -8, 6, 0],
            rotate: [it.rot, it.rot + 14, it.rot - 8, it.rot + 6, it.rot],
            opacity: [0, 1, 1, 1, 0.9],
          }}
          transition={{
            duration: it.dur,
            delay: it.delay,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        >
          <Leaf d={it.d} className="h-full w-full" />
        </motion.div>
      ))}
    </div>
  );
}
